import { useId } from "react";
import {
  Card,
  VField,
  VInput,
  VRadioGroup,
  VTextarea,
  type VRadioOption,
} from "@/components/ui";
import type { RequestMotivation } from "@/domains/requests/api/types";

const YES_NO: ReadonlyArray<VRadioOption<"yes" | "no">> = [
  { value: "yes", label: "Ja" },
  { value: "no", label: "Neen" },
];

type StepMotivationProps = {
  value: RequestMotivation;
  onChange: (next: RequestMotivation) => void;
};

export function StepMotivation({ value, onChange }: StepMotivationProps): React.JSX.Element {
  const complianceName = useId();
  const patch = (partial: Partial<RequestMotivation>): void => onChange({ ...value, ...partial });

  return (
    <Card padding="lg" className="space-y-4">
      <VField
        label="20. Reden van aanvraag camera"
        htmlFor="reason"
        required
        hint="Vul hier de reden in waarom je deze aanvraag aanmaakt (bv. overlast, observatie, …)."
      >
        <VTextarea
          id="reason"
          rows={3}
          value={value.reason}
          onChange={(e) => patch({ reason: e.target.value })}
        />
      </VField>

      <VField
        label="21. PV-nummer, dossiernummer of dossiernaam"
        htmlFor="pvNumber"
        hint="Vul het PV-nummer, dossiernummer of dossiernaam in indien van toepassing."
      >
        <VInput
          id="pvNumber"
          value={value.pvNumber}
          onChange={(e) => patch({ pvNumber: e.target.value })}
        />
      </VField>

      <VField
        label="22. Nummer bijzondere machtiging"
        htmlFor="specialAuth"
        hint="Indien je beschikt over een bijzondere machtiging Politie/Parket (PolKol, BIM, anders), vul het nummer in."
      >
        <VInput
          id="specialAuth"
          value={value.specialAuthorization}
          onChange={(e) => patch({ specialAuthorization: e.target.value })}
        />
      </VField>

      <VField
        label="23. Meervoudige inzet camera"
        htmlFor="multipleDeployment"
        hint="Omschrijf of meervoudige van de locatie nodig is met meerdere assets en in dewelke volgorde."
      >
        <VTextarea
          id="multipleDeployment"
          rows={3}
          value={value.multipleDeployment}
          onChange={(e) => patch({ multipleDeployment: e.target.value })}
        />
      </VField>

      <VField
        label="24. Conformiteit wetgeving"
        required
        hint="Houd je de gestelde cameratoezichtwet, de geldende richtlijnen en de wettelijke handelingen aangaande beelden in aanmerking?"
      >
        <VRadioGroup
          name={complianceName}
          value={value.complianceConfirmed ? "yes" : "no"}
          options={YES_NO}
          onChange={(v) => patch({ complianceConfirmed: v === "yes" })}
          orientation="horizontal"
        />
      </VField>
    </Card>
  );
}
